import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useCallback,
} from "react";
import api from "../utils/api";
import { useAuth } from "./AuthContext";

const GlobalCountContext = createContext();
export const useGlobalCounts = () => useContext(GlobalCountContext);

export function GlobalCountProvider({ children }) {
  const [counts, setCounts] = useState({
    notifications: 0,
    tasks: 0,
    followups: 0,
    mentions: 0,
    conversations: 0,
    followup_overdue: 0,
  });
  const [loading, setLoading] = useState(false);
  const { isAuthenticated, bootChecked, logout } = useAuth();

  const fetchCounts = useCallback(async () => {
    const token = localStorage.getItem("access_token");
    if (!bootChecked || !token || !isAuthenticated) return;

    try {
      setLoading(true);
      const res = await api.get("/global_counts/");
      setCounts(res.data);
    } catch (err) {
      if (err.response?.status === 401) {
        logout();
        return;
      }
      console.error("Error fetching global counts:", err);
    } finally {
      setLoading(false);
    }
  }, [isAuthenticated, bootChecked, logout]);

  useEffect(() => {
    if (!bootChecked || !isAuthenticated) return;

    // wait 1 second after login to guarantee token propagation
    const timer = setTimeout(() => fetchCounts(), 1000);

    const handleVisibility = () => {
      if (!document.hidden && isAuthenticated) fetchCounts();
    };
    document.addEventListener("visibilitychange", handleVisibility);

    return () => {
      clearTimeout(timer);
      document.removeEventListener("visibilitychange", handleVisibility);
    };
    // ✅ CRITICAL FIX: Remove fetchCounts from dependency array
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, bootChecked]); // Only these - NOT fetchCounts

  const refreshCounts = useCallback(() => {
    fetchCounts();
  }, [fetchCounts]);

  return (
    <GlobalCountContext.Provider value={{ counts, refreshCounts, loading }}>
      {children}
    </GlobalCountContext.Provider>
  );
}
